import { linkCategories } from '@/mocks/links';
import FooterSection from '@/pages/home/components/FooterSection';

export default function LinksPage() {
  return (
    <main className="w-full">
      {/* Page Hero */}
      <section className="relative w-full h-48 md:h-64 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/6d8f9988acc78e63317ad207afdb7f48.jpg"
          alt="Links and Fan Sites"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-[#2a0a3d]/90"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 pt-16">
          <p className="text-[#ffd700] text-xs font-bold tracking-widest uppercase mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Resources
          </p>
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Links &amp; Fan Sites
          </h1>
        </div>
      </section>

      {/* Links Content */}
      <section className="w-full px-6 md:px-12 py-14 bg-[#f8f6fb]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {linkCategories.map((category) => (
              <div key={category.id} className="bg-white rounded-lg overflow-hidden border border-gray-100">
                {/* Category Header */}
                <div className="px-6 py-4 border-b-2 border-[#4a1a6b]">
                  <h2 className="text-sm font-black text-[#4a1a6b] tracking-widest uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
                    {category.title}
                  </h2>
                </div>

                {/* Links List */}
                <ul className="divide-y divide-gray-50">
                  {category.links.map((link) => (
                    <li key={link.id}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="flex items-center justify-between px-6 py-3.5 group hover:bg-[#4a1a6b]/5 transition-colors cursor-pointer"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#4a1a6b]/10 group-hover:bg-[#4a1a6b] transition-colors">
                            <i className={`${link.icon} text-sm text-[#4a1a6b] group-hover:text-white transition-colors`}></i>
                          </div>
                          <span className="text-sm font-semibold text-[#2a0a3d] group-hover:text-[#4a1a6b] transition-colors" style={{ fontFamily: "'Oswald', sans-serif" }}>
                            {link.name}
                          </span>
                        </div>
                        <span className="whitespace-nowrap px-3 py-1 rounded-full bg-[#4a1a6b] text-white text-[10px] font-black tracking-widest uppercase group-hover:bg-[#ffd700] group-hover:text-[#4a1a6b] transition-all cursor-pointer" style={{ fontFamily: "'Oswald', sans-serif" }}>
                          Visit
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterSection />
    </main>
  );
}
